<template>
  <div class="top">
    <img class="logo" v-if="isShowLogo" :src="OemLogo.show && OemLogo.url ? OemLogo.url : defaultLogo" alt="" :style="{ maxWidth: OemLogo.show && OemLogo.url ? '150px' : '' }" />
  </div>
  <div id="login">
    <div class="popup">
      <span class="loginTitle">
        <div class="titleTxt">管家登录</div>
        <div class="userLogin" @click="jumpUnify">客户登录</div>
      </span>
      <el-form ref="ruleFormRef" :model="ruleForm">
        <el-form-item prop="phone" :rules="rules.phone">
          <el-input v-model="ruleForm.phone" placeholder="请输入手机号" maxlength="11" autofocus @keyup.enter="handleLogin(ruleFormRef)" />
        </el-form-item>
        <AuthCode v-model="ruleForm.img_code_answer" :img="imgCodeState.img" :getImageCode="onGetImageCode" />
        <el-form-item prop="code" :rules="rules.code">
          <el-input v-model="ruleForm.code" class="w-50 m-2" placeholder="请输入验证码" @keyup.enter="handleLogin(ruleFormRef)">
            <template #suffix>
              <el-link :underline="false" :disabled="disabled" size="small" type="primary" @click="getCode()">{{ disabled ? time + "秒" : "获取验证码" }}</el-link>
            </template>
          </el-input>
        </el-form-item>
        <!-- <el-form-item>
          <sliding-block ref="slidingBlockRef" @change="onCheckSlidingBlock" />
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="handleLogin(ruleFormRef)" :loading="loading" style="background: #30a2f2">登录</el-button>
        </el-form-item>
        <el-form-item v-if="dev">
          <el-button type="primary" @click="fakeLogin()" :loading="loading" style="background: #30a2f2">模拟登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
  <div class="bottom">
    <div class="bottom_text" v-show="!Secret">京ICP备16066022号 | 京公网安备11011402014132号</div>
  </div>
</template>

<script lang="ts" setup>
import { reactive, ref } from "vue";
import { ElMessage, FormInstance } from "element-plus";
// import SlidingBlock from "./slidingBlock.vue";
import useCode from "@/hooks/login/useCode";
import useLogin from "@/hooks/login/useLogin";
import { AcMode } from "@/config/config";
// import useAWSC from "@/utils/useAWSC/index.js";
import { NvcReject } from "@/hooks/login/useNvc";
import { isPhone } from "@/utils/validator";
import { useRoute } from "vue-router";
import commonApi from "@/api/common/commonApi";
import defaultLogo from "@/assets/logo_dgj.png";
import { AgentLonginOem } from "@/api/common/commonLimit";
import { useStore } from "vuex";
import useIcon from "@/hooks/login/useIcon";
import { getQueryVariable } from "@/router";
import AuthCode from "@/components/authCode/authCode.vue";
import { useImgCode } from "@/hooks/useCode";
const { setTitle, updateFavicon } = useIcon();

const store = useStore();

const route = useRoute();
console.log(route, "route");
const OemLogo = ref({
  show: false,
  url: "",
  windowTitle: "",
  icoUrl: "",
  Secret: "",
});
const isShowLogo = ref(false);
const Secret = ref(getQueryVariable("Secret") || route.query.Secret || "");
// if (Secret.value) {
sessionStorage.setItem("Secret", String(Secret.value));
console.log(Secret, "Secret");
commonApi
  .apiAgentLonginOem({ Secret: Secret.value } as AgentLonginOem)
  .then((res: any) => {
    console.log(res, "res");
    const resData = res.data;
    isShowLogo.value = true;
    OemLogo.value.show = true;
    if (resData.isOK) {
      OemLogo.value.url = resData.oemUrl;
      OemLogo.value.icoUrl = resData.titleoemUrl;
      OemLogo.value.windowTitle = resData.titleName;
      OemLogo.value.Secret = Secret.value + "";
      // 新的标题
      setTitle(resData.isOK ? resData.titleName : "");
      // 新的icon
      updateFavicon(resData.isOK ? resData.oemWebsiteIcon : "");
      changeWindow();
      store.dispatch("setCurrentOEMInfo", OemLogo.value);
    } else {
      document.title = "财务大管家";
    }
    console.log(OemLogo, "OemLogo");
  })
  .catch(() => {
    document.title = "财务大管家";
    isShowLogo.value = true;
  });
// } else {
//   document.title = "财务大管家";
//   isShowLogo.value = true;
// }

const changeWindow = () => {
  // var link = (document.querySelector("link[rel*='icon']") || document.createElement("link")) as any;
  // link.type = "image/x-icon";
  // link.rel = "shortcut icon";
  // link.href = OemLogo.value.icoUrl;
  // document.getElementsByTagName("head")[0].appendChild(link);
  document.title = OemLogo.value.windowTitle;
};

// const slidingBlockRef = ref<InstanceType<typeof SlidingBlock>>();

// useAWSC(
//   (data: string) => {
//     if (slidingBlockRef.value) {
//       slidingBlockRef.value?.unload;
//       isSlidingBlock.value = false;
//     }
//     if (isCode.value) {
//       console.log(data, "datadata1");
//       // 验证码滑块
//       getCode(data);
//     } else if (isLogin) {
//       if (acMode.value == AcMode.AGENT) {
//         // 登录滑块
//         handleLogin(ruleFormRef.value, data);
//       }
//     }
//   },
//   null,
//   null,
//   "login"
// );

const dev = import.meta.env.DEV;

const { getVerificationCode, disabled, time, isSlidingBlock: isCode } = useCode(60);
const { login, isSlidingBlock: isLogin, acMode } = useLogin();

const isSlidingBlock = ref<boolean>(false);
const loading = ref(false);
const ruleForm = reactive({
  phone: "",
  code: "",
  img_code_answer: "",
});
const { onGetImageCode, imgCodeState, getParams } = useImgCode(ruleForm);
const ruleFormRef = ref<FormInstance>();
const rules = reactive({
  phone: [
    { required: true, message: "请输入手机号" },
    { validator: isPhone, trigger: "change" },
  ],
  code: [{ required: true, message: "请输入验证码" }],
});

/** 模拟登录 */
const fakeLogin = async () => {
  ruleForm.phone = "18601970200";
  ruleForm.code = "999";
  executeLogin();
};

/** 获取验证码 */
const getCode = async (nvc?: string) => {
  console.log(nvc, "nvcnvc");
  if (isSlidingBlock.value) {
    ElMessage({ message: "请先滑动完成验证", type: "warning" });
    return;
  }
  await getVerificationCode(ruleForm.phone, nvc, getParams)
    .then((res) => {
      isSlidingBlock.value = false;
    })
    .catch(loginFail);
};
/** 手机号登录 */
const handleLogin = (formEl: FormInstance | undefined, nvc?: string) => {
  if (isSlidingBlock.value) {
    ElMessage({ message: "请先滑动完成验证", type: "warning" });
    return;
  }
  if (!formEl) return;
  formEl.validate(async (valid) => {
    if (valid) {
      // 登录
      executeLogin(nvc);
    } else {
      setTimeout(() => {
        var isError = document.getElementsByClassName("is-error");
        isError?.[0]?.querySelector("input")?.focus();
      }, 1);
    }
  });
};

/** 执行登录 */
const executeLogin = async (nvc?: string) => {
  try {
    loading.value = true;
    const res = await login({ ...ruleForm }, AcMode.AGENT, nvc);

    isSlidingBlock.value = false;
  } catch (err) {
    loginFail(err as NvcReject);
  } finally {
    loading.value = false;
  }
};

// const onCheckSlidingBlock = (e: boolean) => {
//   isSlidingBlock.value = e;
// };
/** 错误信息处理 */
const loginFail = (e: NvcReject) => {
  // const { statusVal, slide } = e;
  // if (statusVal) slidingBlockRef.value?.loginFail(statusVal, slide);
  // else window?.nvc?.reset();
};
// 跳转Unify
const jumpUnify = () => {
  console.log(import.meta.env.MODE, "环境变量");
  window.open(Secret.value ? `${import.meta.env.VITE_APP_UNIFY_BASE_URL}?Secret=${Secret.value}` : `${import.meta.env.VITE_APP_UNIFY_BASE_URL}`, "_blank");
};
</script>

<style lang="less" scoped>
.top {
  height: 95px;
  background-color: #fff;
  padding-left: 20px;
  display: flex;
  align-items: center;
  .logo {
    // height: @logoHeight;
    // margin: 25px 0 0 20px;
    max-height: 80px;
  }
}
.bottom {
  height: 95px;
  line-height: 95px;
  background-color: #fff;

  .bottom_text {
    font-size: 16px;
    font-weight: 400;
    color: black;
    text-align: center;
  }
}
#login {
  width: 100%;
  height: calc(100% - 190px);
  // height: 82%;
  background: url(../../assets/new_bgc.png) no-repeat;
  background-size: 100% 100%;

  .popup {
    position: absolute;
    box-sizing: border-box;
    top: 20%;
    right: 4%;
    width: 358px;
    // min-height: 420px;
    background-color: #fff;
    // background-color: pink;
    // box-shadow: 0 3px 10px 14px #e8f9fe85;
    border-radius: 15px;
    padding: 50px;
    display: flex;
    flex-direction: column;
    // justify-content: center;
    .loginTitle {
      color: #454f63;
      // font-weight: bold;
      font-size: 22px;
      margin-bottom: 30px;
      display: flex;
      > .userLogin {
        flex: 1;
        padding-left: 23px;
        font-size: 14px;
        padding-top: 9px;
        &:hover {
          text-decoration: underline;
          cursor: pointer;
        }
      }
      .titleTxt {
        // border-right: 2px solid #adadad;
        color: black;
        font-weight: 500;
        flex: 1;
      }
      .titleTxt::after {
        content: "";
        position: absolute;
        top: 84px;
        left: 14.5%;
        width: 12%;
        border-radius: 5px;
        height: 3px;
        background-color: #30a2f2;
      }
    }
    .el-form-item {
      margin-bottom: 30px;
      &:last-child {
        margin-bottom: 0;
      }
    }

    & > div {
      // display: flex;
      // margin-top: 20px;
      // height: 50px;

      span {
        font-size: 12px;
        color: hsl(218deg 93% 67%);
      }
    }

    .CAPTCHA {
      :deep(.el-button--primary) {
        background-color: #fff;
        border-color: #fff;
        color: hsl(218deg 93% 67%);
      }
      :deep(.el-button > span) {
        display: inline-block;
        width: 60px;
        text-align: center;
      }
    }

    .btn {
      width: 95%;
      padding: 1px 11px;
      margin-top: 20px;
    }

    .el-button--primary {
      width: 100%;
      height: 40px;
    }

    :deep(.el-input__wrapper) {
      border: none;
      box-shadow: none;
      padding: 0;
    }

    :deep(.el-input__wrapper:hover) {
      border: none;
      box-shadow: none;
    }

    :deep(.el-input__wrapper.is-foucs) {
      border: none;
      box-shadow: none;
    }

    :deep(.el-input__inner) {
      border-bottom: 1px solid #ccc;
    }
  }
}
</style>
